<ng-container [ngSwitch]="fieldType">
    <cm-text-input
        *ngSwitchCase="CUSTOM_FIELD_TYPES.STRING"
        [formControl]="control"
        [placeholder]="placeholder"
        [ngClass]="fieldClass"
    >
    </cm-text-input>
    <cm-textarea
        *ngSwitchCase="CUSTOM_FIELD_TYPES.TEXTAREA"
        [formControl]="control"
        [placeholder]="placeholder"
        [ngClass]="fieldClass"
    >
    </cm-textarea>
    <cm-datepicker
        *ngSwitchCase="CUSTOM_FIELD_TYPES.DATE"
        [formControl]="control"
        [placeholder]="placeholder"
        [ngClass]="fieldClass"
    >
    </cm-datepicker>
    <cm-number-input
        *ngSwitchCase="CUSTOM_FIELD_TYPES.NUMBER"
        [formControl]="control"
        [placeholder]="placeholder"
        [maskConfig]="numberMaskConfig"
        [ngClass]="fieldClass"
    >
    </cm-number-input>
    <cm-select
        *ngSwitchCase="CUSTOM_FIELD_TYPES.BOOLEAN_SELECT"
        [formControl]="control"
        [options]="booleanSelectOptions"
        [ngClass]="fieldClass"
    >
    </cm-select>
    <cm-select
        *ngSwitchCase="CUSTOM_FIELD_TYPES.SELECT_COUNTRY"
        [formControl]="countriesOptions.length ? control : defaultValue"
        [options]="countriesOptions"
        [ngClass]="fieldClass"
    >
    </cm-select>
    <cm-select
        *ngSwitchCase="CUSTOM_FIELD_TYPES.SELECT_STATE"
        [formControl]="statesOptions.length ? control : defaultValue"
        [options]="statesOptions"
        [ngClass]="fieldClass"
    >
    </cm-select>
    <cm-number-input
        *ngSwitchCase="CUSTOM_FIELD_TYPES.PHONE_NUMBER"
        [formControl]="control"
        [maskConfig]="phoneMaskConfig"
        [placeholder]="placeholder"
        [ngClass]="fieldClass"
    ></cm-number-input>
    <cm-text-input *ngSwitchDefault [formControl]="control" [placeholder]="placeholder"></cm-text-input>
</ng-container>
